import { withInstall } from '@zoryn/utils'
import Divider from './src/divider.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZDivider: SFCWithInstall<typeof Divider> = withInstall(Divider)
export default ZDivider

export * from './src/divider'
